import { useStatsHoursByLawyer } from '../../../hooks/queries/useStats';
import { CollaboratorLink } from '../../collaborators/CollaboratorLink';

function fmt(n: number): string {
  return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 }).format(n);
}

export function HoursByLawyerChart() {
  const { data = [], isLoading, error } = useStatsHoursByLawyer();

  if (isLoading) {
    return <p className="text-sm text-cime-text-muted">Chargement…</p>;
  }
  if (error) {
    return <p className="text-sm text-red-600">Erreur de chargement.</p>;
  }
  if (data.length === 0 || data.every((d) => Number(d.hours_total ?? 0) === 0)) {
    return <p className="text-sm text-cime-text-muted">Aucune heure saisie.</p>;
  }

  const max = Math.max(1, ...data.map((d) => Number(d.hours_total ?? 0)));

  return (
    <div className="space-y-2">
      {data.map((row) => {
        const total = Number(row.hours_total ?? 0);
        const billed = Number(row.hours_billed ?? 0);
        const totalPct = (total / max) * 100;
        const billedPct = total > 0 ? (billed / total) * totalPct : 0;
        return (
          <div key={row.collaborator_id} className="text-sm">
            <div className="flex items-baseline justify-between mb-1">
              {row.collaborator_id ? (
                <CollaboratorLink collaboratorId={row.collaborator_id} title={`Voir le profil de ${row.full_name ?? ''}`}>
                  <span className="text-cime-text-primary font-medium">
                    {row.full_name ?? '—'}
                  </span>
                </CollaboratorLink>
              ) : (
                <span className="text-cime-text-primary font-medium">
                  {row.full_name ?? '—'}
                </span>
              )}
              <span className="text-cime-text-muted tabular-nums">
                {fmt(billed)} / {fmt(total)} h
              </span>
            </div>
            <div className="h-2 bg-neutral-100 rounded overflow-hidden relative">
              <div
                className="absolute left-0 top-0 h-full bg-neutral-300"
                style={{ width: `${totalPct}%` }}
              />
              <div
                className="absolute left-0 top-0 h-full bg-cime-primary"
                style={{ width: `${billedPct}%` }}
              />
            </div>
          </div>
        );
      })}
      <div className="flex items-center gap-4 text-xs text-cime-text-muted mt-3 pt-2 border-t border-neutral-100">
        <span className="flex items-center gap-1.5">
          <span className="inline-block w-3 h-3 bg-cime-primary rounded-sm" />
          Facturées
        </span>
        <span className="flex items-center gap-1.5">
          <span className="inline-block w-3 h-3 bg-neutral-300 rounded-sm" />
          Totales
        </span>
      </div>
    </div>
  );
}
